import { React, useState, useEffect, createContext, useMemo } from "react";
import { useHistory, useLocation } from "react-router-dom";
import request from "../../../../Helpers/API";
import {
    TextField,
    MenuItem,
    InputAdornment,
    Modal,
    Box
} from "@mui/material";
import Swal from "sweetalert2";
// import { LoaderScreen } from "../../components/LoaderScreen";
import PlantillaScreen from "../../../helpers/PlantillaScreen";
import { ValidaContacto } from "../../../Clientes/Contacto/ValidaContacto";

const AgregarContactoCotizacionesModal = ({ open, onClose, idcliente, folio, update = null }) => {
    // const [ContactoNuevo, setContactoNuevo] = useState({
    //     idcliente: idcliente,
    //     tipocontacto: "PO",
    //     mediocontacto: "W",
    //     valor: "",
    //     comentarios: "",
    // });
    const [medios, setMedios] = useState({
        idcliente: idcliente,
        medio: "W",
        cobranza: "",
        credito: "",
        ventas: "",
        // posventas: "",
        refacciones: "",
        servicio: ""
    });

    // console.log(ContactoNuevo.idcliente)
    const [datosContacto, setDatosContacto] = useState([]);
    const [contactosRegistrados, setContactosRegistrados] = useState();
    const [openModalEditar, setOpenModalEditar] = useState(false);
    const [ejecucionEliminar, setEjecucionEliminar] = useState(false);
    const [ejecucionGuardar, setEjecucionGuardar] = useState(false);

    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    useEffect(() => {
        if (
            idcliente === undefined ||
            idcliente === null ||
            idcliente === 0 ||
            idcliente === "0" ||
            idcliente === "" ||
            idcliente === "-1" ||
            idcliente === "-1"
        ) {
            return;
        }
        request
            .get(`ClientesDatosContacto/ListadoContactosRegistrados?idcliente=${Number(idcliente)}&mediocontacto=${"W"}`)
            .then((result) => {
                setContactosRegistrados(result);
            })
            .catch((error) => {
                Swal.fire("Clientes", JSON.stringify(error), "error");
            });
    }, [idcliente, open]);

    useEffect(() => {
        if (!contactosRegistrados || !Array.isArray(contactosRegistrados)) return;

        const nuevosMedios = {
            medio: "W",
            cobranza: "",
            credito: "",
            ventas: "",
            // posventas: "",
            servicio: "",
            refacciones: ""
        };

        contactosRegistrados.forEach((contacto) => {
            switch (contacto.tipo_contacto) {
                case "CO": // cobranza
                    nuevosMedios.cobranza = contacto.valor || "";
                    break;
                case "CR": // crédito
                    nuevosMedios.credito = contacto.valor || "";
                    break;
                case "VE": // ventas
                    nuevosMedios.ventas = contacto.valor || "";
                    break;
                // case "PO": // posventa
                //     nuevosMedios.posventas = contacto.valor || "";
                case "SE": // servicio
                    nuevosMedios.servicio = contacto.valor || "";
                case "RE": // refacciones
                    nuevosMedios.refacciones = contacto.valor || "";
                    break;
                default:
                    break;
            }
        });

        setMedios(nuevosMedios);
    }, [contactosRegistrados]);

    const guardarContacto = async () => {
        const comentariosFijos = "";

        const contactoPorDepto = [
            { key: "cobranza", tipo: "CO" },
            { key: "credito", tipo: "CR" },
            { key: "ventas", tipo: "VE" },
            // { key: "posventas", tipo: "PO" },
            { key: "servicio", tipo: "SE" },
            { key: "refacciones", tipo: "RE" },
        ];

        const defaultValor = contactoPorDepto.reduce((acc, { key }) => {
            const val = medios[key]?.trim();
            return acc || (val ? val.toUpperCase() : "");
        }, "");

        if (!defaultValor) {
            Swal.fire("Validación", "Debes ingresar al menos un medio de contacto", "warning");
            return;
        }

        const contactosValidados = [];
        for (const { key, tipo } of contactoPorDepto) {
            const valor = medios[key]?.trim() || defaultValor;

            const stateTemporal = {
                mediocontacto: key,
                tipocontacto: tipo,
                valor: valor.toUpperCase(),
                comentarios: comentariosFijos,
            };

            const valido = ValidaContacto(stateTemporal);
            if (!valido) {
                Swal.fire("Validación", `El valor ingresado en ${key.toUpperCase()} no es válido`, "error");
                return;
            }

            contactosValidados.push({
                ...valido,
                idcliente: Number(idcliente),
                orden: 0,
                medio_contacto: medios.medio,
                tipo_contacto: tipo,
                comentarios: comentariosFijos,
                valor: valor.toUpperCase(),
                folio: folio
            });
        }

        try {
            const resultados = await Promise.all(
                contactosValidados.map((contacto) =>
                    request.post("DashboardPostventa/AgregarContactoCotizacionesRefacciones", contacto)
                )
            );

            const ultimoResultado = resultados[resultados.length - 1];
            await Swal.fire("Clientes", "Contactos guardados correctamente", "success");

            if (update !== null) {
                update()
            }

            setDatosContacto(ultimoResultado.listado);
            setLoader({ ...loader, mostrar: false });
            setEjecucionGuardar(false);
            setEjecucionEliminar(false);
        } catch (error) {
            Swal.fire("Clientes", JSON.stringify(error), "error");
        }
    };

    return (
        <Modal open={open} onClose={onClose}>
            {/* <div className="plantilla-screen-filtro-container-modal-container-asdsad"> */}
            <div className="agregar-contacto-cotizaciones-modal">
                <div className="agregar-contacto-modal-detalle">
                    <div className="agregar-contacto-modal-detalle-formulario">
                        <div className="agregar-contacto-modal-formulario-plantilla">
                            <div className="plantilla-screen-filtro-container" id="mdlFiltros-modal">
                                <PlantillaScreen
                                    titulo={`Registrar Datos de Contacto`}
                                    className_main={1}
                                    className={"plantilla-screen-filtro-container-modal"}
                                >
                                    <div className="cerrar-modal-button" onClick={onClose}>X</div>

                                    <div className={`agregar-contacto-modal-formulario-plantilla-agregar`}>
                                        <TextField
                                            fullWidth
                                            label="Cobranza"
                                            size="small"
                                            color="success"
                                            value={medios.cobranza}
                                            onChange={({ target }) =>
                                                setMedios({
                                                    ...medios,
                                                    cobranza: target.value.toUpperCase(),
                                                })
                                            }
                                            inputProps={{
                                                type: 'number',
                                                style: { height: '20px' },
                                                onInput: (e) => {
                                                    if (medios.medio === "T" || medios.medio === "W") {
                                                        const value = e.target.value.replace(/[^0-9]/g, ''); // Eliminar caracteres no numéricos
                                                        // Limitar longitud a 10
                                                        if (value.length <= 10) {
                                                            e.target.value = value;
                                                        } else {
                                                            e.target.value = value.slice(0, 10);
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                        <TextField
                                            fullWidth
                                            label="Credito"
                                            sx={{ mt: 2 }}
                                            size="small"
                                            color="success"
                                            value={medios.credito}
                                            onChange={({ target }) =>
                                                setMedios({
                                                    ...medios,
                                                    credito: target.value.toUpperCase(),
                                                })
                                            }
                                            inputProps={{
                                                type: 'number',
                                                style: { height: '20px' },
                                                onInput: (e) => {
                                                    if (medios.medio === "T" || medios.medio === "W") {
                                                        const value = e.target.value.replace(/[^0-9]/g, ''); // Eliminar caracteres no numéricos
                                                        // Limitar longitud a 10
                                                        if (value.length <= 10) {
                                                            e.target.value = value;
                                                        } else {
                                                            e.target.value = value.slice(0, 10);
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                        <TextField
                                            fullWidth
                                            label="Ventas"
                                            size="small"
                                            color="success"
                                            sx={{ mt: 2 }}
                                            value={medios.ventas}
                                            onChange={({ target }) =>
                                                setMedios({
                                                    ...medios,
                                                    ventas: target.value.toUpperCase(),
                                                })
                                            }
                                            inputProps={{
                                                type: 'number',
                                                style: { height: '20px' },
                                                onInput: (e) => {
                                                    if (medios.medio === "T" || medios.medio === "W") {
                                                        const value = e.target.value.replace(/[^0-9]/g, ''); // Eliminar caracteres no numéricos
                                                        // Limitar longitud a 10
                                                        if (value.length <= 10) {
                                                            e.target.value = value;
                                                        } else {
                                                            e.target.value = value.slice(0, 10);
                                                        }
                                                    }
                                                }
                                            }}
                                        />
                                        <TextField
                                            fullWidth
                                            label="Servicio"
                                            size="small"
                                            color="success"
                                            sx={{ mt: 2 }}
                                            value={medios.servicio}
                                            onChange={({ target }) =>
                                                setMedios({
                                                    ...medios,
                                                    servicio: target.value.toUpperCase(),
                                                })
                                            }
                                            inputProps={{
                                                type: 'number',
                                                style: { height: '20px' },
                                                onInput: (e) => {
                                                    if (medios.medio === "T" || medios.medio === "W") {
                                                        const value = e.target.value.replace(/[^0-9]/g, ''); // Eliminar caracteres no numéricos
                                                        // Limitar longitud a 10
                                                        if (value.length <= 10) {
                                                            e.target.value = value;
                                                        } else {
                                                            e.target.value = value.slice(0, 10);
                                                        }
                                                    }
                                                }
                                            }}
                                        />

                                        <TextField
                                            fullWidth
                                            label="Refacciones"
                                            size="small"
                                            color="success"
                                            sx={{ mt: 2 }}
                                            value={medios.refacciones}
                                            onChange={({ target }) =>
                                                setMedios({
                                                    ...medios,
                                                    refacciones: target.value.toUpperCase(),
                                                })
                                            }
                                            inputProps={{
                                                type: 'number',
                                                style: { height: '20px' },
                                                onInput: (e) => {
                                                    if (medios.medio === "T" || medios.medio === "W") {
                                                        const value = e.target.value.replace(/[^0-9]/g, ''); // Eliminar caracteres no numéricos
                                                        // Limitar longitud a 10
                                                        if (value.length <= 10) {
                                                            e.target.value = value;
                                                        } else {
                                                            e.target.value = value.slice(0, 10);
                                                        }
                                                    }
                                                }
                                            }}
                                        />

                                        <div className="agregar-contacto-modal-buttons">
                                            <button
                                                className="agregar-contacto-modal-button-guardar"
                                                onClick={() => guardarContacto()}
                                            >
                                                Agregar
                                            </button>
                                        </div>
                                    </div>
                                </PlantillaScreen>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* </div> */}
        </Modal >
    );
};


export default AgregarContactoCotizacionesModal;